export default __webpack_public_path__ + "static/media/img_utpal.aa87a0a1.png";